import _objectSpread from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/Users/laurogripa/code/kusama/kappasigmamu.github.io/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["controlId", "as"];
import * as React from 'react';
import { useMemo } from 'react';
import FormContext from './FormContext';
import { jsx as _jsx } from "react/jsx-runtime";
const FormGroup = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      controlId,
      // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
      as: Component = 'div'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const context = useMemo(() => ({
    controlId
  }), [controlId]);
  return /*#__PURE__*/_jsx(FormContext.Provider, {
    value: context,
    children: /*#__PURE__*/_jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }))
  });
});
FormGroup.displayName = 'FormGroup';
export default FormGroup;